import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import styles from "./featured.module.css"; // Import the CSS module

const Featured = ({ data }) => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const brandsPerPage = 16;
  const brandPages = (data || []).reduce((pages, brand, index) => {
    const pageIndex = Math.floor(index / brandsPerPage);
    if (!pages[pageIndex]) pages[pageIndex] = [];
    pages[pageIndex].push(brand);
    return pages;
  }, []);
  const brandPageCount = Math.max(1, brandPages.length);

  const handleBeforeChange = (current, next) => {
    setCurrentSlide(next); // Update the current slide index
  };
  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    arrows: false,
    infinite: brandPages.length > 1,
    autoplay: brandPages.length > 1,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    beforeChange: handleBeforeChange,
    responsive: [
    ],
  };

  const handleBrandClick = (name) => {
    if (!name) return;
    navigate('/SimilarProductList', {
      state: {
        source: 'manufacturer',
        manufacturer: name,
        selectedAttributes: [{ attribute: "Manufacturer", values: [name] }],
      },
    });
  };

  const slider2Ref = useRef(null);

  const handlePrevClick = () => {
    if (slider2Ref.current) slider2Ref.current.slickPrev();
  };

  const handleNextClick = () => {
    if (slider2Ref.current) slider2Ref.current.slickNext();
  };

  return (

    <section className={styles.content}>
      <div className={styles.section}>
        <div className={styles.sectionHeading}>
          <div>
            <span className={styles.eyebrow}>Authorized supply network</span>
            <h2>Featured brands</h2>
          </div>
          <p>Trusted brands for your components.</p>
        </div>
        {
          data?.length > 0 &&
          <Slider ref={slider2Ref} {...sliderSettings} className={styles.slider}>

            {brandPages.map((page, pageIndex) => (
              <div key={`brand-page-${pageIndex}`}>
                <div className={styles.brandGrid}>
                  {page.map((thumbnail) => (
                    <div key={thumbnail?._id || thumbnail?.name} className={styles.slidecontant}>
                      <button
                        type="button"
                        className={styles.brandCard}
                        onClick={() => handleBrandClick(thumbnail?.name)}
                        aria-label={thumbnail?.name ? `View ${thumbnail.name} products` : 'View brand products'}
                      >
                        <img src={thumbnail?.thumbnail?.photo[0]} alt={thumbnail?.name || 'Featured brand logo'} className={styles.brandLogo} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </Slider>
        }

        {/* Dots for Slide Progress */}
        <div className={styles.footersec}>
          <div className={styles.dotsContainer}>
            {Array.from({ length: brandPageCount }).map((_, index) => (
              <div
                key={index}
                className={`${styles.dot} ${index === currentSlide % brandPageCount ? styles.active : ""}`}
              ></div>
            ))}
          </div>
          {/* Navigation Arrows */}
          <div className={styles.sliderArrows}>
            <button type="button" className={styles.prevArrow} onClick={handlePrevClick} aria-label="Previous brands">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="39"
                  height="39"
                  rx="19.5"
                  stroke="#B3B3B3"
                />
                <path
                  d="M23 14.5L17 20.5L23 26.5"
                  stroke="#656567"
                  strokeWidth="2"
                />
              </svg>
            </button>
            <button type="button" className={styles.nextArrow} onClick={handleNextClick} aria-label="Next brands">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="40" height="40" rx="20" fill="#512DA8" />
                <path
                  d="M17 14.5L23 20.5L17 26.5"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Featured;
